module.exports = __webpack_public_path__ + "img/dieselConsumption.8bfa468f.svg";